import analyticsService from "src/services/Analytics.service";

export const trackDownloadVideo = (props: { trigger: "notification-center" | string; sequenceSid: string }) =>
  analyticsService.track("download-video", {
    action: "download",
    trigger: props.trigger,
    sequenceSid: props.sequenceSid,
  });
